export type ParseKeepPagesResult =
  | { ok: true; keep: Set<number> }
  | { ok: false; errorMessage: string };

function parsePositiveInt(token: string): number | null {
  if (!/^\d+$/.test(token)) return null;
  const value = Number.parseInt(token, 10);
  if (!Number.isFinite(value) || value < 1) return null;
  return value;
}

export function parseKeepPages(input: string, pageCount: number): ParseKeepPagesResult {
  if (pageCount < 1) {
    return { ok: false, errorMessage: 'В PDF нет страниц.' };
  }

  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return { ok: true, keep: new Set() };
  }

  const keep = new Set<number>();
  const tokens = trimmed.split(',');

  for (const rawToken of tokens) {
    const token = rawToken.trim();
    if (token.length === 0) {
      return { ok: false, errorMessage: 'Пустой фрагмент между запятыми.' };
    }

    const addPage = (page: number): ParseKeepPagesResult | null => {
      if (page > pageCount) {
        return {
          ok: false,
          errorMessage: `Страница ${page} вне диапазона 1–${pageCount}.`,
        };
      }
      keep.add(page);
      return null;
    };

    if (token.includes('-')) {
      const parts = token.split('-');
      if (parts.length !== 2) {
        return { ok: false, errorMessage: `Некорректный диапазон: «${token}».` };
      }
      const startRaw = parts[0]?.trim() ?? '';
      const endRaw = parts[1]?.trim() ?? '';
      const start = parsePositiveInt(startRaw);
      const end = parsePositiveInt(endRaw);
      if (start === null || end === null) {
        return { ok: false, errorMessage: `Некорректный диапазон: «${token}».` };
      }
      const from = Math.min(start, end);
      const to = Math.max(start, end);
      for (let page = from; page <= to; page += 1) {
        const error = addPage(page);
        if (error) return error;
      }
      continue;
    }

    const page = parsePositiveInt(token);
    if (page === null) {
      return { ok: false, errorMessage: `Некорректный номер страницы: «${token}».` };
    }
    const error = addPage(page);
    if (error) return error;
  }

  return { ok: true, keep };
}
